import {
  Maximize2, Building2, BarChart3, Shield, Sparkles,
} from "lucide-react";
import { FloorAreaInsight } from "./FloorAreaInsight";

const SIGNAL_COLORS = {
  spatial: { border: "border-l-cipher-green", icon: "text-cipher-green" },
  unlockability: { border: "border-l-blue-400", icon: "text-blue-400" },
  market: { border: "border-l-cipher-gold", icon: "text-cipher-gold" },
  integrity: { border: "border-l-amber-400", icon: "text-amber-400" },
};

const SIGNAL_ICONS = {
  spatial: Maximize2,
  unlockability: Building2,
  market: BarChart3,
  integrity: Shield,
};

export function WhatsPossible({ signals, floorAreaInsight, lens }) {
  const topSignals = (signals || []).slice(0, 3);

  return (
    <div data-testid="section-whats-possible" className="space-y-2">
      {topSignals.map((signal) => {
        const Icon = SIGNAL_ICONS[signal.category] || Sparkles;
        const colors = SIGNAL_COLORS[signal.category] || SIGNAL_COLORS.spatial;
        return (
          <div
            key={signal.id}
            className={`flex items-center gap-3 border-l-[3px] ${colors.border} bg-white/[0.04] rounded-r-lg pl-3 pr-4 py-2.5`}
            data-testid={`opportunity-card-${signal.id}`}
          >
            <Icon className={`w-4 h-4 ${colors.icon} flex-shrink-0`} />
            <p className="text-sm text-white/80 leading-snug">{signal.short_copy}</p>
          </div>
        );
      })}

      <FloorAreaInsight insight={floorAreaInsight} lens={lens} />
    </div>
  );
}
